import React, { useContext } from 'react';
import { Layout, Space, Typography, Image, Button } from 'antd';
import './customer.css';
import customers from '../../images/customers.svg';
import { HomePageContext } from '../contexts/AppContext';

const Customer = () => {
    const { Content } = Layout;
    const { translate } = useContext(HomePageContext);


    return (
        <>
            <Space id='customer-main-container'>
                <Content role="main" id='customer-container'>
                    <div className='customer-image-animation'>
                        <Image role="img" className='img' src={customers} preview={false} alt="A black woman smiling" />
                    </div>
                    <div className='customer-content-texts'>
                        <Typography.Title role="heading" level={5} className="section-title-left">{translate('make_customer')}</Typography.Title>
                        <Typography.Title role="heading" level={3} className="section-caption-left">{translate('customer_title')}</Typography.Title>
                        <Typography.Paragraph role="textbox" className='section-paragraph'>{translate('customer_text')}</Typography.Paragraph>
                        <Button role="button" aria-label={'learn more'} type='primary' ghost>{translate('btn_learn_more')}</Button>
                    </div>
                </Content>
            </Space>
        </>
    )
}

export default Customer